import React from 'react';
import styled, { css } from 'styled-components';
import { CustomBoxImage } from '../../box-image/CustomBoxImage';

const TooltipBox = styled.div`
    position: relative;
    cursor: pointer;
`;

const Tooltip = styled.div`
    visibility: hidden;
    background-color: #fff;
    border: 1px solid #cecece;
    color: #787b83;
    text-align: center;
    border-radius: 5px;
    padding: 10px;

    position: absolute;
    z-index: 1;
    
    ${TooltipBox}:hover &{
        visibility: visible;
    }
`;

export function CustomToolTip({
    tooltipBox,
    tooltipText,
    tooltipStyle,
    ...props
}) {
    return (
        <TooltipBox className='tooptip-box' {...props}>
            <div>
                {tooltipBox ?? (
                    < CustomBoxImage
                        src='/images/icon/exclamation_default_a3a8b2.svg'
                    />
                )}
            </div>
            <Tooltip className='tooltip-text' style={{...tooltipStyle}}>
                {tooltipText}
            </Tooltip>
        </TooltipBox>
    )
}
